<template>
    <div class="group-terms-list">
      <h2>Group Terms & Conditions</h2>
      <button class="btn btn-primary mb-4" @click="addGroupTerm">Add Language</button>
      <v-client-table
        :data="groupTerms"
        :columns="columns"
        :options="options"
        @row-click="editGroupTerm"
      ></v-client-table>
    </div>
  </template>

  <script>
  const api = window.api;
  export default {
    name: 'GroupTermsList',
    data() {
      return {
        groupTerms: [],
        columns: ['Language', 'Description', 'actions'],
        options: {
          headings: {
            Language: 'Language',
            Description: 'Description',
            actions: 'Actions'
          },
          sortable: ['Language'],
          filterable: ['Language'],
          perPage: 10,
          perPageValues: [10, 20, 50],
          skin: 'table table-striped table-hover',
        }
      };
    },
    mounted() {
      this.fetchGroupTerms();
    },
    methods: {
      async fetchGroupTerms() {
        let res = await api.get('/api/groupterm/');
        this.groupTerms = (res || []).map((r) => ({
          ...r,
          Description: this.preview(r.Description),
        }));
      },
      preview(html) {
        const text = (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        return text.length > 120 ? `${text.slice(0, 120)}...` : text;
      },
      editGroupTerm(data) {
        this.$router.push({name: 'groupterm', params: {id: data.row.id}})
      },
      addGroupTerm() {
        this.$router.push({name: 'groupterm', params: {id: null}})
      },
    }
  }
  </script>

  <style scoped>
  .group-terms-list {
    margin: 20px;
  }
  .mb-4 {
    margin-bottom: 16px;
  }
  </style>
